'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/excavator (3).png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import table, { Table } from 'react-bootstrap'
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}

const MovableExcavator = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        // category: "Roof Service",
        // customer: "David Bravis",
        // startDate: "21 April 2024",
        // endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "#", iconClass: "icon-linkedin-in" },
        { href: "#", iconClass: "icon-facebook-f" },
        { href: "#", iconClass: "icon-instagram" },
        { href: "#", iconClass: "icon-Vector" },
    ]);
    const [serviceDetails] = useState({

        // text1: "Horizontal Automatic Container Shear is ideal for cutting the metal shaped in different cross sections like round, square, channel, angle, I shape, plate and various waste structural metal at cold state. It brings convenience to the baling, storage and transportation of scrap metal materials, and also offers qualified furnace charges for smelting plants.",
        image1: ServiceDetailsImg,
        title: "Movable Excavator",
        text2: "An excavator is a heavy-duty machine that is primarily used for loading large amounts of scrap metal and other materials. These machines are often equipped with powerful hydraulic systems that allow them to lift and move heavy objects with ease. They typically have a long arm or boom that is fitted with a variety of different attachments, such as a claw or grapple, which are used to pick up and manipulate scrap metal.This type of excavator is suitable to handle the scarp in open yard as well as cover shed, the steel wheel most commonly used in scrap yards .this excavator is better for feeding continuouslycontainer shear machine to get better efficiency, this modified excavator consume less electricity as compare to the diesel machine.",

    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    {/* <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div> */}
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>

                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>

                                </div>
                                <div>

                                </div>

                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>
                        {/* <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                    <h4 className="service-details__sidebar-title">Main Service</h4>
                                    <ul className="service-details__service-list list-unstyled">
                                        <li>
                                            <Link to="/peak-performance-roofing">
                                                {" "}
                                                <span className="icon-dubble-arrow-right" />
                                                Movable Excavator
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/movable-excavator">
                                                {" "}
                                                <span className="icon-dubble-arrow-right" />
                                                Skyline Roofing Solutions
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/hydraulic-scrap-baler">
                                                {" "}
                                                <span className="icon-dubble-arrow-right" />
                                                Hydraulic Scrap Baler
                                            </Link>
                                        </li>
                                        <li className="active">
                                            <Link to="/reliable-roof-repair">
                                                {" "}
                                                <span className="icon-dubble-arrow-right" />
                                                Horizontal Automatic Container Shear
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/top-notch-roofing-restoration">
                                                {" "}
                                                <span className="icon-dubble-arrow-right" />
                                                Top Notch Roofing Restoration
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment >
    );
};

export default MovableExcavator;
